<script setup>
import {computed, inject} from "vue";
import {getNoun, getNumberWithNoun} from "@/helpers/string";
import UsersActivities from "@/views/enterprise/needsDashboard/UsersActivities.vue";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
const emit = defineEmits(['addUser', 'upgrade']);

const dashboardData = inject("dashboardData");
const isFree = computed(() => store.getters.onlyNeeds);

</script>

<template>
    <aside class="need-admin__sidebar">
        <div class="need-admin__card">
            <div class="need-admin__card__inner">
                <h3 class="need-admin__title">Your Team</h3>

                <ul class="need-admin__seats-list">
                    <li>
                        <span>Explorer Seats</span>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="{'width': dashboardData.users.explorers + '%'}" :aria-valuenow="dashboardData.users.non_admins" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <span>{{dashboardData.users.explorers}}/100</span>
                    </li>
                    <li v-if="isFree">
                        <span>Admin Seats</span>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <span>1/1</span>
                    </li>
                </ul>

                <a
                    class="need-admin__button need-admin__button--bordered need-admin__button--invite w-100 mb-3"
                    @click="emit('addUser')"
                >
                    Invite Team Members
                </a>

                <a
                    v-if="isFree"
                    @click="emit('upgrade')"
                    class="need-admin__button need-admin__button--upgrade w-100 mb-4"
                >
                    Upgrade To Add Admins
                </a>
            </div>

            <div v-if="isFree" class="need-admin__card__color">
                <h5 class="heading5 heading5--secondary">You’re on the free plan - your team can do more.</h5>

                <p>Unlock search, market intelligence and custom reporting to drive faster decisions</p>

                <button class="need-admin__button-light" @click="emit('upgrade')">Unlock Full Access</button>
            </div>
        </div>

        <div v-if="dashboardData.ecosystems.ecosystems_count || dashboardData.awaiting_review || dashboardData.users.inactive" class="need-admin__card need-admin__card--round">
            <div class="need-admin__card__inner">
                <template v-if="dashboardData.ecosystems.ecosystems_count">
                    <h3 class="need-admin__title">Network Activity</h3>

                    <div class="need-admin__plate">
                        <header class="need-admin__plate__header">
                            <h6 class="heading6 heading6--ecosystem">Ecosystem Contributions</h6>

                            <a v-if="false" href="#" class="link">View All</a>
                        </header>
                        <div class="need-admin__plate__content">
                            <ul class="need-admin__stat">
                                <li>
                                    <big>{{dashboardData.ecosystems.solutions_count}}</big>

                                    <p>{{ getNoun('solution', dashboardData.ecosystems.solutions_count) }} sent by {{getNumberWithNoun('ecosystem partner', dashboardData.ecosystems.ecosystems_count)}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>

                <div v-if="dashboardData.awaiting_review || dashboardData.users.inactive" class="need-admin__plate">
                    <header class="need-admin__plate__header">
                        <h6 class="heading6 heading6--alert">Team Bottlenecks</h6>
                    </header>
                    <div class="need-admin__plate__content">
                        <ul class="need-admin__stat">
                            <li v-if="dashboardData.awaiting_review">
                                <big>{{dashboardData.awaiting_review}}</big>

                                <p><a class="need-admin__stat__link">{{getNoun('Need', dashboardData.awaiting_review)}} awaiting review</a></p>
                            </li>
                            <li v-if="dashboardData.users.inactive">
                                <big>{{dashboardData.users.inactive}}</big>

                                <p><a class="need-admin__stat__link">Inactive {{getNoun('user', dashboardData.users.inactive)}}</a></p>
                            </li>
                        </ul>
                    </div>
                </div>

                <UsersActivities/>
            </div>
        </div>
    </aside>
</template>

<style scoped>

</style>
